import {
    BrowserClient,
    defaultStackParser,
    getDefaultIntegrations,
    makeFetchTransport,
    httpClientIntegration,
    browserTracingIntegration,
    Scope,
    withScope
} from "@sentry/react";

export const SENTRY_PROJECT_NAME = "FASTSHIFT_PORTAL";

export const getFastshiftSentryClient = () =>
    new BrowserClient({
        dsn: "https://7094bf0a2bc1951c62fadea8306b7ca2@o55978.ingest.us.sentry.io/4510151685242880",
        transport: makeFetchTransport,
        stackParser: defaultStackParser,
        enabled: process.env["CLIENT_LIBRARY_ENV"] !== "local",
        environment: process.env["CLIENT_LIBRARY_ENV"],
        release: window.BUILD_KEY,
        dist: window.BUILD_KEY,
        integrations: [
            ...getDefaultIntegrations({}),
            httpClientIntegration(),
            browserTracingIntegration()
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["localhost", /^https:\/\/atlassian\.com/]
    });

export const getFastshiftSentryScope = () => {
    const scope = new Scope();
    scope.setClient(getFastshiftSentryClient());
    scope.setTag("projectName", SENTRY_PROJECT_NAME);
    return scope;
};

export const sendFastshiftSentryAlert = (
    errorMsg: string,
    httpStatus?: number,
    statusText?: string,
    url?: string
) => {
    const fastshiftSentryScope = getFastshiftSentryScope();
    withScope(fastshiftSentryScope, () => {
        fastshiftSentryScope.setContext("response", {
            status: httpStatus,
            statusText: statusText,
            url: url
        });
        fastshiftSentryScope.captureException(new Error(errorMsg));
    });
};

export const beforeCaptureWithScope = (section: string) => (scope: Scope) => {
    scope.setClient(getFastshiftSentryClient());
    scope.setTag("projectName", SENTRY_PROJECT_NAME);
    scope.setContext("error-meta", {
        section
    });
};
